import modalTemplate from './rsvps-quick-add.tpl.html';

class QuickAddGuestCustomWorkflow {
    constructor(Error, $uibModal, $http, SweetAlert, Alert) {
        this.error = Error;
        this.modal = $uibModal;
        this.api = $http;
        this.sweetAlert = SweetAlert;
        this.alert = Alert;

        this.key = 'quick-add-guest-custom';
        this.title = 'Quick - Add Guest';
        this.level = 'highlight';
        this.order = 20;
        this.icon = 'plus-circle';
    }

    action(payload, store) {
        const guestlistId = _.get(store, 'state.permanentFilters.guestlist_id');
        if (guestlistId) {
            return this.modal.open({
                templateUrl: modalTemplate,
                controllerAs: 'vm',
                resolve: {
                    guestlistInformation: () => {
                        return this.loadGuestlistInformation(guestlistId).then((guestlistInformation) => {
                            return guestlistInformation;
                        }, (e) => {
                            this.error.default(e);
                        })
                    },
                    companyProfile: () => {
                        return this.loadCompanyProfile().then((companyProfile) => {
                            return companyProfile;
                        }, (e) => {
                            this.error.default(e);
                        })
                    },
                    parentRsvpId: () => {
                        return _.get(store, 'state.permanentFilters.parent_rsvp_id');
                    }
                },
                controller: ['Error', '$http', '$uibModalInstance', 'Deposit', '$filter', 'guestlistInformation', 'companyProfile', '$rootScope', 'parentRsvpId', 'Alert', 'Users', QuickAddContactCustomModalController]
            }).result.then((response) => {
                this.alert.success('Success','Booking created');
                if (store) {
                    store.dispatch('getData');
                }
                return response.rsvp;
            }, (e) => {
                if (e && e !== 'escape key press') {
                    this.error.default(e);
                }
            });
        }
    }

    /**
     *
     */
    loadGuestlistInformation(guestlistId) {
        return this.api.get(`guestlists/${guestlistId}`).then((response) => {
            return response.data.data;
        }, (e) => {
            return e;
        })
    }

    loadCompanyProfile() {
        return this.api.get(`auth/profile?include=company`).then((response) => {
            return response.data.data.company.data;
        }, (e) => {
            return e;
        })
    }
}

class QuickAddContactCustomModalController {
    constructor(Error, $http, $uibModalInstance, Deposit, $filter, guestlistInformation, companyProfile, $rootScope, parentRsvpId, Alert, Users) {
        this.error = Error;
        this.api = $http;
        this.modalInstance = $uibModalInstance;
        this.depositService = Deposit;
        this.filter = $filter;
        this.guestlistInformation = guestlistInformation;
        this.companyProfile = companyProfile;
        this.rootScope = $rootScope;
        this.alert = Alert;
        this.userStore = Users;
        this.parentRsvp = null;
        this.isQuickAdd = true;
        this.fields = [];

        this.guestlistInformation.settings.enabled_fields.forEach(function (field) {
            let keys = field.split('.');
            let formatedField = this.guestlistInformation.enabled_fields[keys[0]][keys[1]];
            if (formatedField.type === 'bool') {
                formatedField.type = 'boolean';
            }
            if (formatedField.type === 'string') {
                formatedField.type = formatedField.multiline ? 'textarea' : 'textbox';
                if (formatedField.enum) {
                    formatedField.type = 'select';
                    formatedField.name = formatedField.label;
                    if (formatedField.name === 'Sex') {
                        formatedField.enum = Object.values(formatedField.enum).map(o => o.toLowerCase());
                    } else {
                        formatedField.enum = Object.values(formatedField.enum);
                    }
                }
            }
            if (formatedField.type === 'image') {
                formatedField.type = 'media_image';
            }
            if (formatedField.type === 'file') {
                formatedField.type = 'media_file';
            }
            if (formatedField.type === 'color-codes') {
                formatedField.type = 'color_code_select';
                formatedField.enum = Object.values(formatedField.enum);
            }
            if (formatedField.type === 'float') {
                formatedField.type = 'decimal';
            }

            formatedField.name = formatedField.label;
            this.fields.push(
                {...formatedField, key: keys[1], parent: keys[0]}
            );
        }.bind(this));

        this.model = {
            contact: {
                code: '',
                sex: 'unknown',
                addressbook: this.guestlistInformation.settings.add_contacts_to_addressbook
            },
            rsvp: {
                status: _.get(this.userStore, 'state.company.settings.rsvps.default_status'),
                pax_planned: 1,
                guestlist_id: this.guestlistInformation.id,
                parent_rsvp_id: parentRsvpId || null,
                wants_shipping: _.get(this.userStore, 'state.company.settings.shipping.enable_shipping_on_rsvps_by_default'),
                privacy_policy: false,
                media_policy: false
            }
        };

        if (this.model.rsvp.parent_rsvp_id) {
            this._loadParentRsvp();
        }


        this.deposits = {
            countries: {},
            languages: {},
            genders: {},
            states: {},
            rsvpRelations: []
        };
        this.submitting = false;

        this.rsvpCustomFields = _(this.guestlistInformation)
            .map((value, attr) => {
                if (attr.match(/custom_\d*_name/gi) && _.keys(value).length) {
                    value.key = attr.match(/custom_\d*/gi)[0];
                    return value;
                }
            })
            .filter()
            .value();

        this.contactCustomFields = _(this.rootScope.company)
            .map((value, attr) => {
                if (attr.match(/custom_\d*_name/gi) && _.keys(value).length) {
                    value.key = attr.match(/custom_\d*/gi)[0];
                    return value;
                }
            })
            .filter()
            .value();

        this.init();

    }

    init() {
        this._loadDeposits();
        this._prepareRsvpRelationInformation();
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('contacts', 'countries', []).then((value) => {
            this.deposits.countries = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'languages', []).then((value) => {
            this.deposits.languages = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'genders', []).then((value) => {
            this.deposits.genders = value;

            if(_.isUndefined(this.deposits.genders[this.model.contact.sex])) {
                this.model.contact.sex = _.first(Object.keys(this.deposits.genders));
            }
        });
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            this.deposits.states = value;
        });
    }

    isFieldEnabled(slug, searchPartial) {
        const enabledFields = this.guestlistInformation.settings.enabled_fields;
        if (searchPartial) {
            for (let i = 0; i < enabledFields.length; i++) {
                if (_.startsWith(enabledFields[i], slug)) {
                    return true;
                }
            }
        } else {
            return enabledFields.indexOf(slug) !== -1;
        }
    }

    save(form) {
        this.submitting = true;

        if (!this.model.pax_planned || this.model.pax_planned < 1) {
            this.model.pax_planned = 1;
        }

        const contactData = _.clone(this.model.contact),
            rsvpData = _.clone(this.model.rsvp);

        this.api.post(`contacts`, contactData).then((response) => {
            const contact = response.data.data;
            rsvpData.contact_id = contact.id;

            this.api.post(`guestlists/${this.guestlistInformation.id}/rsvps`, rsvpData).then((response) => {
                this.modalInstance.close({
                    contact: contact,
                    rsvp: response.data.data
                })
            }, (e) => {
                this.submitting = false;
                this.alert.handle(e);
            }).finally(() => {
                this.submitting = false;
            })
        }, (e) => {
            this.submitting = false;
            this.alert.handle(e);
        });
    };

    _loadParentRsvp() {
        this.api.get(`rsvps/${this.model.rsvp.parent_rsvp_id}?include=contact`).then((response) => {
            this.parentRsvp = response.data.data;
        })
    }

    cancel() {
        this.modalInstance.dismiss();
    };

    _prepareRsvpRelationInformation() {
        this.deposits.rsvpRelations = [];

        _.each(this.guestlistInformation.rsvp_relation_types, (relationType) => {
            this.api.get(`guestlists/${this.guestlistInformation.id}/available-relations/${relationType.uuid}`).then((response) => {
                this.deposits.rsvpRelations.push({
                    relationType,
                    availableRsvps: _.filter(_.get(response, 'data.data', {}), (v) => {
                        return v.available;
                    })
                });
            });
        })
    }
}


/**
 * @ngdoc service
 * @name checkins.factory:quickAddContact
 *
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .factory('quickAddGuestCustom', [
        'Error',
        '$uibModal',
        '$http',
        'SweetAlert',
        'Alert',
        (Error, $uibModal, $http, SweetAlert, Alert) => new QuickAddGuestCustomWorkflow(Error, $uibModal, $http, SweetAlert, Alert)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/heart-me/quick-add-guest-custom.js